import React from "react";
import styled from "styled-components";

export default React.memo(styled.h5`
  color: var(--bs-dark-navy);
  font-weight: 500;
  font-size: 16px;
`);
